if (!customElements.get('moda-payment-finder')) {
  customElements.define('moda-payment-finder', class extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.plan = this.querySelector('[data-plan]');
      this.rep = this.querySelector('[data-rep]');
      this.next = this.querySelector('[data-continue]');
      this.status = this.querySelector('.mc-finder-status');
      this.heading = this.querySelector('[data-chosen]');
      this.planPlaceholder = this.plan.options[0].textContent;
      this.repPlaceholder = this.rep.options[0].textContent;
      try {
        const response = await fetch(this.dataset.source);
        if (!response.ok) throw new Error('Unavailable');
        this.products = await response.json();
      } catch {
        this.status.textContent = this.dataset.unavailable;
        return;
      }
      this.querySelectorAll('[data-family]').forEach(button => {
        button.addEventListener('click', () => this.choose(button.dataset.family));
        button.disabled = false;
      });
      this.plan.addEventListener('change', () => this.resetRep());
      this.rep.addEventListener('change', () => this.refresh());
      this.next.addEventListener('click', () => {
        const item = this.selection();
        if (!item || this.next.disabled) return;
        const url = new URL(item.url, location.origin);
        if (url.origin === location.origin && url.pathname.startsWith('/products/')) location.assign(url.href);
      });
      const input = this.querySelector('input[type="search"]');
      const results = this.querySelector('[data-results]');
      input.addEventListener('input', () => {
        results.replaceChildren();
        const value = input.value.trim().toLowerCase();
        if (!value) return;
        const matches = this.products.filter(p => !['tmc','rwb','gold','mda'].includes(p.key) && `${p.label} ${p.alias}`.toLowerCase().includes(value));
        if (!matches.length) { results.textContent = this.dataset.none; return; }
        matches.forEach(product => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = product.label;
          button.addEventListener('click', () => this.choose(product.key));
          results.append(button);
        });
      });
    }
    reset(select, label) { select.replaceChildren(new Option(label, '')); select.disabled = true; }
    choose(key) {
      this.chosen = this.products.find(p => p.key === key);
      this.heading.textContent = this.chosen.label;
      this.querySelectorAll('[data-family]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.family === key)));
      this.reset(this.plan, this.planPlaceholder);
      this.reset(this.rep, this.repPlaceholder);
      this.chosen.plans.forEach(p => this.plan.add(new Option(p.label, p.name)));
      this.plan.disabled = this.chosen.plans.length === 0;
      this.refresh();
    }
    resetRep() {
      this.reset(this.rep, this.repPlaceholder);
      const plan = this.chosen?.plans.find(p => p.name === this.plan.value);
      if (plan) {
        Object.keys(plan.reps).sort().forEach(name => this.rep.add(new Option(name, name)));
        this.rep.disabled = Object.keys(plan.reps).length === 0;
      }
      this.refresh();
    }
    selection() { return this.chosen?.plans.find(p => p.name === this.plan.value)?.reps[this.rep.value]; }
    refresh() {
      const item = this.selection();
      this.next.disabled = !item;
      this.status.textContent = item ? `${this.chosen.label} · ${this.plan.selectedOptions[0].textContent} · ${this.rep.value}` : this.chosen?.plans.length === 0 ? this.dataset.unavailable : this.dataset.required;
    }
  });
}
